enum EBetDeleteMode {
    DeleteOutcomes = 'DeleteOutcomes',
    NoDeleteOutComes = 'NoDeleteOutComes',
    NoDeleteOutComesWithMaxBet = 'NoDeleteOutComesWithMaxBet',
}
type BetDeleteMode = 'DeleteOutcomes' | 'NoDeleteOutComes' | 'NoDeleteOutComesWithMaxBet';

enum EBetAcceptMode {
    Fix = 'Fix',
    NotLess = 'NotLess',
    Any = 'Any',
}
type BetAcceptMode = 'Undefined' | 'Fix' | 'NotLess' | 'Any';

enum EBetAdditionalAmountsType {
    Value = 'Value',
    Percentage = 'Percentage',
}

type BetAdditionalAmountsType = 'Undefined' | 'Value' | 'Percentage';

enum EBetAdditionalAmountsTypeCode {
    Undefined = 0,
    Value = 10,
    Percentage = 20,
}

enum EBetType {
    Single = 'Single',
    Express = 'Express',
    System = 'System',
    AllExpresses = 'AllExpresses',
    AllExpressesExceptSingle = 'AllExpressesExceptSingle',
}

type TotalHandicapMode = 'Accept' | 'NotAccept';
type BetDisplayMode = 'Standard' | 'Extended';

export {
    EBetDeleteMode,
    EBetAcceptMode,
    EBetAdditionalAmountsType,
    EBetAdditionalAmountsTypeCode,
    EBetType,
    type BetAcceptMode,
    type BetDeleteMode,
    type TotalHandicapMode,
    type BetAdditionalAmountsType,    
    type BetDisplayMode,
}
